module.exports = __webpack_public_path__ + "img/sc.b43ad340.png";